import { useState } from "react";
import Alert from "../Alert";
import LoadingSpinner from "../LoadingSpinner";
import ModalGeneric from "./ModalGeneric";
import { useGetUsersQuery, useUpdateUserMutation } from "/src/redux/usersApi";
import DynamicEditForm from '../DynamicEditForm';
import { useEffect } from "react";
import ModalError from "./ModalError";
import ModalLoading from "./ModalLoading";
import { accessLevels } from "/src/utils/auth";

const formConfig = {
    autoFocus: true,
    fields: [
        {
            key: 'email',
            title: 'Email',
            type: 'email',
            placeholder: 'johndoe@email.com',
            required: true,
            max: 128,
        },
        {
            key: 'accessLevel',
            title: 'Access Level',
            type: 'dropdown',
            placeholder: '10',
            required: true,
            items: accessLevels,
        },
    ]
}

// modal to show that user needs to install metamask
export default function ModalAdminOptions({callback, className}) {
    const { data: users, error: usersError, isLoading: usersIsLoading } = useGetUsersQuery(); 
    const [updateUser, { error: updateError, isLoading: isUpdating, isSuccess: isUpdateSuccess }] = useUpdateUserMutation();
    const [editItem, setEditItem] = useState(null);
    const [error, setError] = useState(null);

    useEffect(()=>{
        if(updateError){
            setError(updateError.data);
        }else if(isUpdateSuccess){
            setEditItem(null);
        }
    },[updateError, isUpdateSuccess]);

    function onSaveForm(data){
        updateUser(data);
    }
    function onDiscardForm(){
        setEditItem(null);
    }

	return (
        <ModalGeneric title="Admin Options" callback={()=>callback()} className={className}>
            <div className="flex items-center justify-between flex-col">
                {error && <ModalError message={error.message} callback={()=>setError(null)} />}
                {isUpdating && <ModalLoading title="Saving" />}

                {(usersError && (
                    <Alert className="border-t-red-600">
                        <p>Failed to load list of users</p>
                    </Alert>
                )) || (usersIsLoading && (
                    <div>
                        <p>Loading Users...</p>
                        <LoadingSpinner className="w-8" />
                    </div>
                )) || (editItem && (
                    <div>
                        <DynamicEditForm 
                            formConfig={formConfig} 
                            selectedAsset={editItem} 
                            onSave={data=>onSaveForm({...data, _id: editItem._id})} 
                            onDiscard={onDiscardForm} 
                        />
                    </div>
                )) || (
                    <div>
                        <p className="font-light">Select a user to edit</p>
                        <ul className="block py-4">
                            {users && users.length > 0 && users.map(item=>(
                                <li className="block mb-4" key={item._id}>
                                    <button className="btn-invert w-full p-4" onClick={()=>setEditItem(item)}>
                                        <p>{item.email || '<No email on record>'}</p>
                                    </button>
                                </li>
                            ))}
                            {/* <li className="block mb-4">
                                <button className="btn flex w-full p-4" onClick={()=>setEditItem({_type: pTypes.plotOccupant})}>
                                    <UserPlusIcon className="w-6 mr-2" />
                                    <span>Add User</span>
                                </button>
                            </li> */}
                        </ul>
                    </div>
                )}

				<div className="flex justify-center w-full">
					<button className="btn w-full m-4 shadow-lg py-3 px-12 uppercase" 
						onClick={() => callback()}>
						Close
					</button>
				</div>
			</div>
        </ModalGeneric>
	);
}